import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MailingAddressDetails } from "../../../redux/reducers/getPropMailingAddressReducer/mailingAddress";
import { RootState } from "../../../redux/reducers/root";
import AmpButton from "../../common/AmpButton/AmpButton";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import AmpToolTip from "../../common/AmpToolTip/AmpToolTip";
import "./MailingAddress.css";

interface SubmissionsProps {
    onSelect: (submission: MailingAddressDetails) => void;
    isEdit: boolean
}



const StatusLkp: Record<string, string> = {
    "Submitted": "mailing-status-submitted",
    "CLOSED": "mailing-status-closed",
    "PROCESS": "mailing-status-process",
    "OPEN": "mailing-status-open"
}


export default function Submissions(props: SubmissionsProps) {
    const { t } = useTranslation(["property", "login"]);
    const mailingAddressCurrentProp = useSelector((state: RootState) => state.mailingAddressRoot?.mailingAddress);


    // Use submission_id 0 == Current by default
    const [currentSelected, setSelected] = useState(0);

    // find max submission id and select as default
    useEffect(() => {
        const submissions = mailingAddressCurrentProp.submissions;
        if(submissions) {
            if(submissions.length > 0){
                const values: number[] = submissions.map(a => Number(a.submission_id));
                const maxId: number = Math.max(...values);
                setSelected(maxId);
                const maxSub = submissions.filter((obj) => Number(obj.submission_id) === maxId)
                props.onSelect(maxSub[0]);
            } else {
                setSelected(0);
                props.onSelect(mailingAddressCurrentProp.address_data as MailingAddressDetails);
            }
        }
    // eslint-disable-next-line
    }, [mailingAddressCurrentProp.submissions])


    const showRecords = () => {
        if (mailingAddressCurrentProp.submissions) {
            return (mailingAddressCurrentProp.submissions as MailingAddressDetails[]).map((submission: MailingAddressDetails, index: number) => {
                return (generateRow(index + 1, submission, false, false))
            })
        } else {
            return [];
        }

    }

    const onChange = (index: number, submission: MailingAddressDetails) => {
        props.onSelect(submission);
        setSelected(Number(submission.submission_id));
    }

    const generateRow = (index: number, submission: MailingAddressDetails | false, isCurrent: boolean, isHeader: boolean) => {
        const selected = currentSelected === Number((submission as MailingAddressDetails)?.submission_id) || (currentSelected === 0 && isCurrent);
        if (submission && !isCurrent && !isHeader) {
            return (
                
                <div key={index} className={`submission-row ${selected && "active"}`}>
                    <div><input type="radio" name="select" checked={selected} onChange={() => { onChange(index, submission) }} readOnly/></div>
                    <div>{t("ID:")} {submission.submission_id}</div>
                    <div>{new Date(submission.submission_date).toLocaleString()}</div>
                    {submission.status === "CLOSED" ? 
                    (<div className="completed-cell">
                        {t("mailing.mailing-status-closed")} 
                        <AmpToolTip id={"completed-info-popup"} content={t("mailing.completed-hover")} direction="left"/>
                    </div>) :
                    (<div>
                        {t(`mailing.${StatusLkp[submission.status]}`) || submission.status || "Submitted"}
                    </div>)}
                    
                    <div>
                        <AmpButton
                            onClick={() => onChange(index, submission)}
                            type={"submit"}
                            text={t("mailing.view")}
                            disabled={selected}
                        />
                    </div>
                </div>
            );
        } else if (isCurrent && submission) {
            return (
                <div key={index} className={`submission-row ${(selected && "active")}`}>
                    <div><input type="radio" name="select" checked={selected} onChange={() => { onChange(index, submission) }} readOnly/></div>
                    <div>{t("mailing.current")}</div>
                    <div></div>
                    <div></div>
                    <div>
                        <AmpButton
                            onClick={() => onChange(index, submission)}
                            type={"submit"}
                            text={t("mailing.view")}
                            disabled={selected}
                        />
                    </div>

                </div>
            );
        } else if (isHeader) {
            return (
                <div key={index} className={`submission-row header`}>
                    <div></div>
                    <div>{t("mailing.submission-id")}</div>
                    <div>{t("mailing.submission-time")}</div>
                    <div>{t("mailing.subimssion-status")}</div>
                    <div></div>
                </div>
            );
        }
        return <></>;

    }

    useEffect(() => {
        if (props.isEdit) {
            setSelected(-1);
        }
    }, [props.isEdit])

    const isSubmissions = mailingAddressCurrentProp.submissions && mailingAddressCurrentProp.submissions.length > 0

    return (
        <AmpLoadingSpinner loading={mailingAddressCurrentProp.loading}>
            <form className={`mailing-address-content ${props.isEdit && "disabled"}`}>
                <div className="title-row">
                    {t("mailing.submissions")}
                </div>
                <div className="form-content submissions">
                    {generateRow(-1, mailingAddressCurrentProp.address_data, false, true)}
                    {isSubmissions ? <></> : generateRow(0, mailingAddressCurrentProp.address_data, true, false)}
                    {showRecords().reverse()}
                </div>
            </form>
        </AmpLoadingSpinner>
    );

}